<template>
  <div class="contest-image-preview selectable">
    <img v-if="resolvedImageUrl" :src="resolvedImageUrl" :alt="id" class="contest-image-preview-image" @click="open">
    <div>
      <p>Votes: {{ votes.votes }}</p>
      <button class="button-secondary" v-if="!voted" @click="voteForImage">
        <span>
          Vote
        </span>
      </button>
    </div>

  </div>

</template>

<script setup>
import apiService from '@/services/apiService'
import {onMounted, onUnmounted, ref} from 'vue'

const props = defineProps({
  id: Number,
  contest_id: String,
  voted: Boolean
})

const resolvedImageUrl = ref(null)
let votes = ref(0);

const emit = defineEmits(['open', 'vote'])

function open() {
  emit('open', props.id)
}

function voteForImage() {
  emit('vote', props.id);
}

onMounted(async () => {
  const response = await apiService.getImageSignedUrl(props.id)
  resolvedImageUrl.value = response.url

  const vote_res = await apiService.getVotesForImageInContest(props.contest_id, props.id);
  votes.value = vote_res;
})

onUnmounted()
</script>

<style scoped>
.contest-image-preview {
  width: 30%;
  height: 10rem;
}

.contest-image-preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>